<template>
  <el-dialog title="详情" :visible.sync="visible" width="50%">
    <el-form :model="data" ref="addForm" label-width="90px">
      <el-form-item label="员工头像:" prop="name">
        <el-image
          class="header-bg"
          :src="data.avatar"
          fit="fill"
          style="width: 100px; height: 100px;border-radius: 50%;"
          v-if="data.avatar"
        >
          <div slot="error" class="image-slot">
            <i class="el-icon-picture-outline"></i>
          </div>
        </el-image>
        <span v-else class="header-bg"></span>
      </el-form-item>
      <el-form-item label="员工姓名:" prop="name">{{data.userName}}</el-form-item>
      <el-form-item label="职位:" prop="name">
        {{data.postName}}
      </el-form-item>
       <el-form-item label="手机号:" prop="name">
        {{data.phoneNumber}}
      </el-form-item>
      <el-form-item label="个人简介:" prop="name">
        {{data.userIntroduction}}
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { saveFile, queryFolderList } from "@/api/saas/package";
import { mapState } from "vuex"; 
import FileUpload from "@/views/crm/components/fileUpload";

export default {
  name: "AddClueDialog",
  components: {
    FileUpload
  },
  props: {},
  data() {
    return {
      title: '',
      disabled: false,
      visible: false,
      folderList: [],
      fileObjs: [],
      rules: {
        fileName: [
          { required: true, message: "请输入文件名称", trigger: "change" }
        ],
        folderId: [{ required: true, message: "请选择文件夹", trigger: "change" }]
      },
      data: {
        fileName: null,
        folderName: null,
        description: null,
        fileSize: null,
        fileType: '',
        fileUrl: null,
        folderId: null,
      }
    };
  },
  watch: {
    visible(val) {
      if (!val) {
        this.resetForm("addForm");
      }
    }
  },
  methods: {
    open(data) {
      this.visible = true;
      this.data = data
      console.log('data', this.data)
    }
  }
};
</script>
<style lang="scss" scoped>
.header-bg{
  display: inline-block;
  width: 100px; 
  height: 100px;
  background:#eee;
  border-radius: 50%;
  background: url(../../../../../assets/decorate/default-header.png) no-repeat center;
  background-size: 100%;
}
</style>
